<template>
  <div>
    <div>
      <FilterCard :applied-filter-count="appliedFilterCount">
        <b-row>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Returned Date"
              label-for="v-ref-no"
            >
              <div class="position-relative">
                <AdvancedDateFilter
                  :date-value="filters['osk27.created_at']"
                  :opens="'right'"
                  :clear-icon="false"
                  @update="updateDateRange('osk27.created_at', $event)"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Warehouse"
              label-for="current_warehouse"
            >
              <v-select
                v-model="filters['app_warehouses.id']"
                :options="warehouseOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Warehouse"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="filters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </FilterCard>
    </div>
    <div>
      <b-card
        no-body
      >
        <div
          class="m-2"
        >
          <b-row>
            <b-col
              class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
            >
              <div>
                <ReportTableButtons
                  :items="items"
                  :json_fieldz="json_fields"
                  :name="`${downloadReportName} - Page ${page}.xls`"
                  :bulkname="`${downloadReportName}.xls`"
                  :fetch="fetcReturnOrderOriginWHIdNoPagination"
                  :use-queue-download="true"
                  @refresh="fetcReturnOrderOriginWHId"
                  @queue-download="downloadQueueExcel"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <b-overlay
          id="overlay-background"
          blur="10px"
          opacity="0.30"
          rounded="sm"
          variant="light"
        >
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
            :json_fields="json_fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            show-empty
            sticky-header="100vh"
            @sort-changed="sortChanged"
          >
            <template #empty>
              <TableDataFetching
                :rows="items"
                :data-loading="dataLoading"
              />
            </template>
            <template #head()="{ field }">
              <div
                class="sortable-header"
              >
                <span class="header-text">{{ field.label }}</span>
                <feather-icon
                  v-if="field.sortable"
                  :icon="sort === field.key
                    ? 'ArrowUpIcon'
                    : 'ArrowDownIcon'"
                  size="14"
                />
              </div>
            </template>
            <template #cell(returned_date)="data">
              {{ __dateTimeFormatter(data.value) }}
            </template>
            <template #cell(customer_phone)="data">
              <div>{{ data.item.customer_phone }}</div>
              <div>{{ data.item.customer_secondary_phone }}</div>
            </template>
            <template #cell(cod_value)="data">
              {{ __numberWithCommas(data.value, true) }}
            </template>
            <template #cell(warehouse_name)="data">
              {{ data.item.temp_warehouse_name || data.item.warehouse_name }}
            </template>
          </b-table>
        </b-overlay>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-sm-start"
            >
              <label class="mr-1">Per page</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block width-125"
              />
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              md="9"
              class="d-flex align-items-center justify-content-sm-end"
            >
              <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
              <b-pagination
                v-model="page"
                :total-rows="(meta.total)? meta.total : 0"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BRow,
  BTable,
  VBModal,
  BOverlay,
  BPagination,
} from 'bootstrap-vue'
import Filter from '@core/mixins/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/ReportFilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'
import getWarehouseList from '../ReturnOrderOriginWarehouse/WarehouseListDropdown'
import { Tablefields } from './TableFields'

const ReportRepository = RepositoryFactory.get('report')
export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    FilterCard,
    vSelect,
    AdvancedDateFilter,
    BCard,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BOverlay,
    BPagination,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      warehouseOptions: [],
      filters: {
        'osk27.created_at': {
          startDate: null,
          endDate: null,
        },
      },
      tableData: [],
      dataLoading: false,
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50, 100, 200],
      totalRows: 1,
      page: 1,
      meta: {},
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: Tablefields,
      json_fields: {
        'Returned Date': {
          field: 'returned_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Waybill Number': 'waybill_number',
        Merchant: {
          field: 'merchant_name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value}"`, // Wrap the address in double quotes
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        COD: 'cod_value',
        Warehouse: {
          callback: item => `"${item.temp_warehouse_name || item.warehouse_name}"`,
        },
      },
      downloadReportName: 'Returned-To-Sorting-Warehouse-(Invalid-Destination)',
      currentDate: '',
      todayFilterQuery: '',
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetcReturnOrderOriginWHId()
      },
    },
    deep: true,
    page() {
      this.fetcReturnOrderOriginWHId()
    },
    perPage() {
      this.fetcReturnOrderOriginWHId()
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.setThisMonthFilter()
    this.fetcReturnOrderOriginWHId()
    this.warehouseList()
    this.updateFilterCount()
  },
  methods: {
    async fetcReturnOrderOriginWHId() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      try {
        // Get data from API
        const { data } = (await ReportRepository.getreturnOrderOriginWarehouseReportIdV2(this.page, filterQuery, this.perPage))
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetcReturnOrderOriginWHIdNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await ReportRepository.getreturnOrderOriginWarehouseReportIdV2NoPagiantion(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async downloadQueueExcel() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.__showJsonDownloadAlertForAllOrders()
        const filterQuery = this.buildFilterQuery()
        await ReportRepository.queueAssignedOrdersExcelDownload('return_to_origin_warehouse_invalid_destination', filterQuery)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async warehouseList() {
      this.warehouseOptions = await getWarehouseList()
    },
    handleChangePage(page) {
      this.page = page
      this.fetcReturnOrderOriginWHId()
    },
    setThisMonthFilter() {
      const currentMonth = this.monthFilter()
      this.updateDateRange('osk27.created_at', currentMonth)
    },
    applyFilters() {
      this.fetcReturnOrderOriginWHId()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        'osk27.created_at': {
          startDate: null,
          endDate: null,
        },
      }
      this.setThisMonthFilter()
      this.$nextTick(() => {
        this.fetcReturnOrderOriginWHId()
      })
      this.updateFilterCount()
    },
  },
}
</script>
<style lang="scss">

@import '../../../@core/scss/vue/libs/vue-select';
</style>
